import {FormControl} from '@angular/forms';
import {OrderStatus} from '../../dto/order-status';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {RoleService} from '../../services/role.service';
import {MatTableGeneratorComponent} from '../../shared/mat-table-generator/mat-table-generator.component';
import {MultiCrudDataSource} from '../../table-datasouces/multi-crud.datasource';
import {OrdersService} from '../services/orders.service';
import {Order, OrderWithIdent} from '../../dto/order';
import {FileHelper} from '../../helpers/file-helper';
import {toDateString} from '../../providers/app-date-adapter';
import {MatButtonToggle} from '@angular/material/button-toggle';
import {IdentStatus} from '../../dto/ident-status';
import {CompanyService} from '../services/company.service';

import {byNumeric} from 'iso-country-codes';
import {ToastService} from 'angular-toastify';
import {ActivatedRoute, Router} from '@angular/router';
import {PepStatus} from '../../dto/pep-status';
import {ReferralsService} from '../services/referrals.service';
import {BehaviorSubject, ReplaySubject} from 'rxjs';
import {OrdersBadgeService} from "../services/orders-badge.service";

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrdersComponent implements OnDestroy, AfterViewInit, OnInit {

  public dialogRemoveText = 'Removing orders you won\'t be able to navigate to order view from card details';

  public orderStatus = OrderStatus;
  public orderStatuses: string[];
  public provenienceOrder: string;
  public webIdStatus = IdentStatus;
  public orderSpecialStatusSelect = new FormControl();

  public ultimatelyFailedOrdersCount: number;
  public ultimatelyFailedOrdersCount$ = new ReplaySubject<number>();



  pepStatus = PepStatus;
  identStatus = IdentStatus;

  @ViewChild(MatTableGeneratorComponent, {static: true}) table: MatTableGeneratorComponent;

  @ViewChild(MatButtonToggle, {static: false}) allButton: MatButtonToggle;

  @ViewChild(MatButtonToggle, {static: true}) multiButton: MatButtonToggle;

  dataSource = new MultiCrudDataSource(this.ordersService);
  columns = [
    {
      columnDef: 'appDevice', header: '', icon: (row: OrderWithIdent) => {
        if (row.appDevice != null) {
          if (row.appDevice.os == 1) { // ios
            return 'apple';
          } else if (row.appDevice.os == 2) { // android
            return 'android';
          }
        }
        return null;
      },
      sortable: false,


    },
    {
      columnDef: 'virtualOnly', header: '',

      cell: (row: OrderWithIdent) => row.isVirtualOnly ? 'V' : '',
      cellBackgroundColor: (row: OrderWithIdent) => row.isVirtualOnly ? '#bbe4fd' : null,
      sortable: false,


    },
    {
      columnDef: 'creationDate',
      header: 'Creation date',
      cell: (row: OrderWithIdent) => `${toDateString(row.creationDate) || ''}`
    },
    {
      columnDef: 'shippedDate', header: 'Shipping date',
      icon: (row: OrderWithIdent) => {

        if (row.customerPepStatus == PepStatus.possibleMatch || row.customerPepStatus == PepStatus.confirmedMatch) {
          return 'report_problem';
        }

        if (row.shippedDate) {
          return false;
        }
        if (row.customerIdentStatus != IdentStatus.success && row.productIsNoIdentCreationActive) {
          return false; // ready for export, but no-ident settings
        }
        if (row.customerIdentStatus != IdentStatus.success && !row.productIsNoIdentCreationActive) {
          return 'access_time'; // not ready for export
        }

        return false;
      },
      cellColor: (row: OrderWithIdent) => {
        if (row.customerPepStatus == PepStatus.confirmedMatch) {
          return 'red';
        }
        if (row.customerPepStatus == PepStatus.possibleMatch) {
          return 'orangered'; // not ready for export
        }

        if (row.shippedDate) {
          return false;
        }
        if (row.customerIdentStatus == IdentStatus.success) {
          return '#8bc34a'; // ready for export
        }
        if (row.productIsNoIdentCreationActive) {
          return 'gray'; // ready for export, but no-ident settings
        }
        if (!row.productIsNoIdentCreationActive) {
          return 'orangered'; // not ready for export
        }
        return false;
      },

      cell: (row: OrderWithIdent) => {
        if (row.customerPepStatus == PepStatus.possibleMatch || row.customerPepStatus == PepStatus.confirmedMatch) {
          return 'PEP';
        }

        if (row.shippedDate) {
          return toDateString(row.shippedDate); // display shipping date if shipped
        }
        if (row.customerIdentStatus != IdentStatus.success && row.productIsNoIdentCreationActive) {
          return 'SDD'; // ready for export, but no-ident settings
        }

      }
    },
    {
      columnDef: 'firstName',
      header: 'First Name',
      cell: (row: OrderWithIdent) => `${row.firstName}`,
      cellColor: (row: OrderWithIdent) => {
        if (row.customerPepStatus == PepStatus.confirmedMatch) {
          return 'red';
        }
        if (row.customerPepStatus == PepStatus.possibleMatch) {
          return 'orangered'; // not ready for export
        }
        return false;
      }
    },
    {
      columnDef: 'lastName',
      header: 'Last Name',
      cell: (row: OrderWithIdent) => `${row.lastName}`,
      cellColor: (row: OrderWithIdent) => {
        if (row.customerPepStatus == PepStatus.confirmedMatch) {
          return 'red';
        }
        if (row.customerPepStatus == PepStatus.possibleMatch) {
          return 'orangered'; // not ready for export
        }
        return false;
      }
    },
    {columnDef: 'dob', header: 'Date of birth', cell: (row: OrderWithIdent) => `${toDateString(row.dob) || ''}`},
    {columnDef: 'email', header: 'Email', cell: (row: OrderWithIdent) => `${row.email}`},
    {
      columnDef: 'productName',
      header: 'Product',
      cell: (row: OrderWithIdent) => row.productInternalName || row.productShortName || row.productName,
    },
    {columnDef: 'status', header: 'Status', cell: (row: OrderWithIdent) => `${row.statusName}`},
    {
      columnDef: 'countryName',
      header: 'Country',
      cellFlag: (row: OrderWithIdent) => byNumeric[row.countryIsoCode.toString().padStart(3, '0')].alpha2,
      cell: (row: OrderWithIdent) => byNumeric[row.countryIsoCode.toString().padStart(3, '0')].alpha2,
    },
    // { columnDef: "city", header: "City", cell: (row: Order) => `${row.city}` },
    // { columnDef: "externalRef", header: "ExternalRef", cell: (row: Order) => `${row.externalRef}` },
    {columnDef: 'cardName', header: 'Card name', cell: (row: OrderWithIdent) => `${row.cardName}`},
    {columnDef: 'invoiceNumber', header: 'Invoice', cell: (row: OrderWithIdent) => `${row.invoiceNumber || '(none)'}`},

    {
      columnDef: 'cancellationInvoiceNumber',
      header: 'Cancellation Invoice',
      cell: (row: OrderWithIdent) => `${row.cancellationInvoiceNumber || '(none)'}`
    },


    {
      columnDef: 'orderDate',
      header: 'Order date',
      cellBackgroundColor: (row: OrderWithIdent) => row.isReorderOrder ? 'lightskyblue' : null,
      cell: (row: OrderWithIdent) => {
        let ret = toDateString(row.orderDate) || '';
        if (row.isImported) {
          ret += ' (i)';
        }
        if (row.isReorderOrder) {
          ret += ' R';
        }
        return ret;
      }
    },
    {
      columnDef: 'ident', header: 'Ident',
      cellColor: (row: OrderWithIdent) => {
        if (!row.webIdTransaction) {
          return false;
        }
        if (row.customerIdentStatus == IdentStatus.success) {
          return '#8bc34a';
        }
        if (row.customerIdentStatus == IdentStatus.fail) {
          return 'red';
        }
        if (row.customerPepStatus == PepStatus.confirmedMatch) {
          return 'red';
        }
        if (row.customerPepStatus == PepStatus.possibleMatch) {
          return 'orangered';
        }
        if (row.customerIdentStatus == IdentStatus.pending) {
          return '#547bde';
        }

        return false;
      }, icon: (row: OrderWithIdent) => {
        if (!row.webIdTransaction) {
          return false;
        }
        if (row.customerIdentStatus == IdentStatus.success) {
          return 'beenhere';
        }
        if (row.customerIdentStatus == IdentStatus.fail) {
          return 'beenhere';
        }
        if (row.customerPepStatus == PepStatus.confirmedMatch) {
          return 'perm_identity';
        }
        if (row.customerPepStatus == PepStatus.possibleMatch) {
          return 'perm_identity';
        }

        return false;
      },
      cell: (row: OrderWithIdent) => false,
    },
    {
      columnDef: 'partnerCustomerId',
      header: 'Partner #',
      cell: (row: OrderWithIdent) => `${row.partnerCustomerId || ''}`
    },
  ];
  public dateFiltersList = [
    {name: 'dob', header: 'DOB'},
    {name: 'orderDate', header: 'Order date'},
    {name: 'createDate', header: 'Creation date'},
    {name: 'shippedDate', header: 'Shipping date'},
  ];
  companies = [];

  constructor(
    private _toastService: ToastService,
    private roleService: RoleService,
    private ordersService: OrdersService,
    private ordersBadgeService: OrdersBadgeService,
    private changeDetectorRefs: ChangeDetectorRef,
    public companyService: CompanyService,
    private referralsService: ReferralsService,
    private router: Router,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {

  }

  goToReferrals() {
    this.router.navigate(['../referrals']);
  }

  goToExtensionsQueued() {
    this.router.navigate(['../pending-extensions']).then();
  }

  goToConversionsQueued() {
    this.router.navigate(['../pending-conversions']).then();
  }

  goToExportOrders() {
    this.router.navigate(['../orders/export-all-view']).then();
  }

  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }

  ngAfterViewInit(): void {
    this.checkAllButton();

    this.companyService.getAll().subscribe(result => {
      this.companies = result.data;
    });

    if (!this.currentUserIsWallet()) {
      this.ordersService.getUltimatelyFailedOrderStatusCount().subscribe(count => {
        this.ultimatelyFailedOrdersCount = count;
        this.ultimatelyFailedOrdersCount$.next(this.ultimatelyFailedOrdersCount);
      });
    }
  }

  checkAllButton() {
    try {
      this.allButton.checked = true;
      this.provenienceOrder = this.allButton.value === 1 ? 'from_assistant' : (this.allButton.value == 2 ? 'from_import' : 'from_anywhere');

    } catch (e) {
      console.log(e);
    }
  }

  onSearch(isInvalid = false) {
    if (!isInvalid) {
      this.table.applyFilter();
    }
  }

  getViewLink = (item: Order): string => item.id.toString();

  getEditLink = (item: Order): string => item.status >= OrderStatus.Shipped ? null : item.id.toString() + '/edit';

  currentUserIsPartner() {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }

  currentUserIsWallet() {
    return this.roleService.hasRoles('wallet');
  }

  editEnabled() {
    return this.roleService.hasRoles('admin');
  }

  deleteEnabled() {
    return this.roleService.hasRoles('admin');
  }

  multiselectEnabled() {
    return this.roleService.hasRoles(['admin', 'manager', 'agent', 'partner']);
  }

  filterOrdersByProvenience(source: number) {
    this.provenienceOrder = (source == 1 ? 'from_assistant' : (source == 2 ? 'from_import' : 'from_anywhere'));
    this.triggerSearch();
  }

  triggerSearch() {
    this.table.filters.someAdditionalData = this.provenienceOrder;
    this.table.filters.additionalFilterData = this.orderStatuses;

    this.onSearch();
  }

  groupTest(items: number[]) {
    if (items !== null) {
      this.orderStatuses = items.map(item => <string>OrderStatus[item]);
    }
    this.triggerSearch();
  }

  exportOrders() {
    const idList = this.table.selection.selected.map(d => d.id);
    this.ordersService
      .export(idList).subscribe(result => {
      FileHelper.saveFile(result);

      this.ordersService.getStatuses(idList).subscribe(statuses => {
        statuses.forEach(x => {
          const order = this.dataSource.data.find(y => y.id == x.id);
          if (order) {
            order.status = x.status;
            order.statusName = x.statusName;
          }
        });
        this.changeDetectorRefs.detectChanges();
        this.table.refreshTable();
      });
    });
  }

  exportOrdersToPortal() {
    const idList = this.table.selection.selected.map(d => d.id);
    this.ordersService.exportToPortal(idList).subscribe(batch => {
      this._toastService.success('The selected orders have been exported to portal');
      this.ordersBadgeService.clearCache();
      this.router.navigate(['card-creations/' + batch.id], {relativeTo: this.route}).then();
    });
  }

  exportAllOrdersView() {
    this.router.navigate(['export-all-view'], {relativeTo: this.route});
  }

  // WebIdEvent
  onWebStatusChange() {
    this.table.filters.enumFilter = {key: 'OrderSpecialStatus', value: this.orderSpecialStatusSelect.value};
    this.triggerSearch();
  }

  ngOnDestroy() {
    this.table.filters.someAdditionalData = '';
    this.orderStatuses = null;
    this.table.saveTableFilters();
  }

  clearFilter() {
    this.orderSpecialStatusSelect.patchValue(null);

    // this.multiButton.buttonToggleGroup.value = "";

    this.table.clearFilter();
  }

}
